import TabPage from "./../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import BaseSearchPaging2 from "./../factories/search-paging2";

class WorkItemPriority extends BaseSearchPaging2 {

    //#region Constructor

    /**
    * Constructor
    */
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.PermissionForward = "WorkItemPriorityForward";
        this.PermissionBackward = "WorkItemPriorityBackward";
    }

    //#endregion Constructor

    //#region Properties

    /**
    * Work Item Priority Name 
    */ 
    WorkItemPriority: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.WorkItemPriority1();
                case 2:
                    return this.WorkItemPriority2();
                case 3:
                    return this.WorkItemPriority3();
                case 4:
                    return this.WorkItemPriority4();
                case 5:
                    return this.WorkItemPriority5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.WorkItemPriority1(value);
                    break;
                case 2:
                    this.WorkItemPriority2(value);
                    break;
                case 3:
                    this.WorkItemPriority3(value);
                    break;
                case 4:
                    this.WorkItemPriority4(value);
                    break;
                case 5:
                    this.WorkItemPriority5(value);
                    break;
            }
        }
    });

    /**
    *  Work Item Priority Description
    */

    Description: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });

    /**
    *  Primary Key
    */
    WorkItemPriorityId: KnockoutObservable<string> = ko.observable();

    /**
    *  Work Item Priority Title in Deutsch language
    */
    WorkItemPriority1: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Title in English language 
    */
    WorkItemPriority2: KnockoutObservable<string> = ko.observable();

    
    /**
    * Work Item Priority Title in fran�ais language
    */
    WorkItemPriority3: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Title in Romanian language 
    */
    WorkItemPriority4: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Title in Nederlands language 
    */
    WorkItemPriority5: KnockoutObservable<string> = ko.observable();

    /**
    * Weight/Rank of priority  
    */
    Weight: KnockoutObservable<number> = ko.observable();

    /**
    * Work Item Priority Description in Deutsch 
    */
    Description1: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Description in English 
    */
    Description2: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Description in fran�ais 
    */
    Description3: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Description in Romanian 
    */
    Description4: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Priority Description in Nederlands 
    */
    Description5: KnockoutObservable<string> = ko.observable();

    /**
     * Work Item Priority Client Route
     */
    ClientRoute: KnockoutObservable<string> = ko.observable();

    //#endregion Properties

    //#region Public Methods

    /**
    *  Validations
    */
    CompleteCheck = (): JQueryPromise<boolean> | boolean => {
        let completed: boolean;
        completed = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.WorkItemPriority()) || this.Weight() === null) {
            completed = false;
        }
        if (!completed) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }

    /**
     *  Init Url for Initialize page
     */
    public InitUrl(): string {
        return "WorkItemPriority/Init";
    }

    /**
    * Initialization 
    */
    init() {
        return $.when(super.init(), super.InitTabController(), Bao.Session.GetMessage("msgWorkItemTypeTabTitle")()).then(() => {
            const workItemPriorityWorkItemTypeTab = new TabPage('WorkItemPriorityWorkItemTypeTab');
            workItemPriorityWorkItemTypeTab.IsClosable(false);
            workItemPriorityWorkItemTypeTab.Url('WorkItemPriorityWorkItemTypeTab');
            workItemPriorityWorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemTypeTabTitle")());
            workItemPriorityWorkItemTypeTab.AutoSelect = true;
            this.TabController.AddTab(workItemPriorityWorkItemTypeTab);
        });
    }

    /**
     *Translate WorkItem Description Dialog
     */
    TranslateDescription = (): void => {
        let translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }

    /**
     *Translate WorkItem Priority Dialog
     */
    TranslateWorkItemPriority = (): void => {
        let translateDialog = new TranslateDialogViewModel(this.WorkItemPriority1, this.WorkItemPriority2, this.WorkItemPriority3, this.WorkItemPriority4, this.WorkItemPriority5);
        translateDialog.Open().then(() => {
        });
    }

    //#endregion Public Methods

}
export default WorkItemPriority;